import Icon from '../components/Icon.vue'

Icon.register({
  'glass-cheers': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M639.4 433.6c1.7 4.1-0.3 8.7-4.3 10.4l-162.4 67.4c-4 1.7-8.7-0.2-10.4-4.3-8.5-20.4 1.2-43.8 21.6-52.3l22.1-9.2-39.3-103.6c-4.4 0.5-8.8 1.3-13.1 1.3-51.7 0-99.4-33.1-113.4-85.3l-20.2-75.4-20.2 75.4c-14 52.2-61.7 85.3-113.4 85.3-4.3 0-8.7-0.8-13.1-1.3l-39.4 103.6 22.1 9.2c20.4 8.5 30 31.9 21.6 52.3-1.7 4.1-6.3 6-10.4 4.3l-162.3-67.4c-4.1-1.7-6-6.4-4.3-10.5 8.5-20.4 31.8-30.1 52.2-21.6l22.1 9.2 38.7-101.9c-47.9-34.9-64.7-100.2-34.5-152.7l86.6-150.5c8-13.9 25.1-19.8 40-13.6l114.3 47.4 114.3-47.4c14.9-6.1 32-0.3 40 13.6l86.6 150.5c30.3 52.5 13.4 117.8-34.5 152.8l38.7 101.9 22.1-9.2c20.4-8.5 43.8 1.2 52.2 21.6zM275.9 162.1l18.9-70.7-94.5-39.2-36.5 63.4zM364.1 162.1l112.1-46.5-36.5-63.4-94.5 39.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/glass-cheers.js
// module id = 1386
// module chunks = 0